import React from "react";
import Show from "../../../../../utils/show.component";
import { authPaymentTypes } from "../../../parent/data/auth-payment-types";

export const PayoffLoanPopupButton = ({
  OtherAuthLoanOptions,
  selectPaymentType,
  AchIsAllowed,
  lastFour,
}) => {
  const shouldShowPayoffLoan = () => {
    const show = OtherAuthLoanOptions.HasPayoffPermissions ? true : false;

    return show;
  };

  return (
    <Show condition={shouldShowPayoffLoan()}>
      <li>
        <button
          className="f12 mt-0 auth-card-popup-button"
          onClick={() => {
            selectPaymentType(authPaymentTypes.valid.Standard, AchIsAllowed, false, true);
          }}
          data-e2e-id={"payOffLoanButton-" + lastFour}
        >
          Pay Off Loan
        </button>
      </li>
    </Show>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/card-children/popup-menu-buttons/payoff-loan-popup-button.component.js